import React from "react";
import i18n from "../../i18n/i18n";
import {ValidationResultComponent} from "./ValidationResults/ValidationResultComponent";
import {Typography} from "@mui/material";
import { withStyles } from 'tss-react/mui';
import {withTranslation} from "react-i18next";

const styles = {};

class ValidationResults extends React.Component {

    render() {
        const {classes} = this.props;

        if (!this.props.log) {
            return <div/>;
        }
        return (
            <div className={classes.content}>
                <Typography variant="h4" gutterBottom={true}>
                    {i18n.t("codeAssignmentPage:validationResult")}
                </Typography>

                {
                    <ValidationResultComponent validationResult={this.props.log}/>
                }
            </div>
        );
    }
}

const validationResultsWithStyles = withStyles(ValidationResults, styles)

export default withTranslation()(validationResultsWithStyles);
